import styled from 'styled-components';
import { Box } from 'grommet';
import { Sizes } from '@theme/globals/sizing';
import theme from '@theme/sbot.theme';

const colors = theme?.global?.colors;

export const Selectable: typeof Box = styled(Box)<{
  borderRadius?: string;
  align?: string;
}>`
  align-items: ${({ align }) => align || 'center'};
  border-radius: ${({ borderRadius }) =>
    borderRadius || Sizes[8]}; /* Default to Sizes[8] */
  border: 1px solid ${colors ? colors['gray-300'] : '#000'};
  cursor: pointer;
  width: 100%;
  &.is-active {
    border-color: ${colors ? colors['brand'] : '#000'};
    box-shadow: 0 0 0 1px ${colors ? colors['brand'] : '#000'};
  }
`;
